export const functionFlowSteps = [
  "Function define hota hai.",
  "Function ko call kiya jata hai.",
  "Parameter ke through input andar jata hai.",
  "Function process karke output deta hai.",
];

export const functionMistakes = [
  {
    id: "missing-brackets",
    title: "Forgetting ()",
    wrong: "greet",
    right: "greet()",
    explanation: "Function ko run karne ke liye brackets lagana zaroori hota hai.",
  },
  {
    id: "print-vs-return",
    title: "Using print instead of return",
    wrong: "def add(a, b):\n    print(a + b)",
    right: "def add(a, b):\n    return a + b",
    explanation: "return value wapas bhejta hai, print sirf screen par dikhata hai.",
  },
  {
    id: "param-count",
    title: "Wrong parameter count",
    wrong: "greet()",
    right: "greet('Ali')",
    explanation: "Jitne required parameters hon, utni values pass karni hoti hain.",
  },
];

export const functionsQuizQuestions = [
  {
    id: "functions-q1",
    question: "Function ka basic faida kya hai?",
    options: ["Code ko lamba banana", "Code reuse karna", "Sirf output print karna", "Variable banana"],
    correctIndex: 1,
    explanation: "Function reusable block hota hai jo repeat kaam ko short karta hai.",
  },
  {
    id: "functions-q2",
    question: "return aur print mein kya farq hai?",
    options: ["Dono same hain", "print value wapas bhejta hai", "return value wapas bhejta hai", "return sirf comment hai"],
    correctIndex: 2,
    explanation: "return value ko function ke bahar use karne ke liye bhejta hai.",
  },
  {
    id: "functions-q3",
    question: "def greet(name='Guest') mein default value kya hai?",
    options: ["name", "greet", "Guest", "def"],
    correctIndex: 2,
    explanation: "Agar call mein value na di jaye to Guest use hoga.",
  },
];

export const functionsFaqs = [
  {
    question: "Python function kya hota hai?",
    answer: "Function reusable code block hota hai jo input leta hai, process karta hai aur output de sakta hai.",
  },
  {
    question: "return aur print mein farq kya hai?",
    answer: "print sirf output display karta hai, jab ke return value ko function se bahar bhejta hai.",
  },
];
